module.exports = __webpack_public_path__ + "media/images/slider_1-0a21e23987e7b70971e03ea9503cef10.png";